"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("./styles/styles");
var formatting_1 = require("./formatting/formatting");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../gen-src/Localize");
var widgets_1 = require("@tableau/widgets");
var Colors = widgets_1.TabStyles.Colors;
var metadataPanelStyle = typestyle_1.style({ display: 'flex', flexDirection: 'column' }, typestyle_1.media({ minWidth: 0, maxWidth: styles_1.BreakPoints.LARGE }, { marginTop: '40px' }), typestyle_1.media({ minWidth: styles_1.BreakPoints.LARGE + 1 }, { width: '290px', marginLeft: '40px', }));
var columnContainer = typestyle_1.style({ display: 'flex', flexDirection: 'column' }, typestyle_1.media({ minWidth: styles_1.BreakPoints.SMALL + 1, maxWidth: styles_1.BreakPoints.LARGE }, { flexDirection: 'row' }));
var leftColumn = typestyle_1.style(typestyle_1.media({ minWidth: styles_1.BreakPoints.SMALL + 1, maxWidth: styles_1.BreakPoints.LARGE }, { flex: 1, marginRight: '40px' }));
var rightColumn = typestyle_1.style(typestyle_1.media({ minWidth: styles_1.BreakPoints.SMALL + 1, maxWidth: styles_1.BreakPoints.LARGE }, { flex: 1 }));
var sectionMarginBotton = {
    marginBottom: '18px',
    padding: '4px',
};
var metadataTitle = {
    fontWeight: 'normal',
    fontSize: '18px',
    color: Colors.L9,
};
var metadataSubTitle = {
    fontWeight: 'bold',
    fontSize: '14px',
    color: Colors.L9,
    marginBottom: '8px',
};
var metadataText = {
    fontWeight: 'normal',
    fontSize: '12px',
    color: Colors.L9,
    wordWrap: 'break-word',
};
var hiddenUserText = {
    fontWeight: 'normal',
    fontSize: '12px',
    color: '#BFBFBF',
};
var metadataConnectedView = {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '177px',
    height: '108px',
    display: 'inline-block',
    border: '1px solid #D8D8D8',
    borderRadius: '1px',
    boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.15)',
};
var metadataHorizontalLine = {
    border: '0.5px solid #D8D8D8',
};
var flexRow = {
    display: 'flex',
};
var fixedFlexColumn = {
    // Make sure to update the width of this column whenever the
    // text inside changes. The goal is to have about 16px of space
    // between the widest text in this column and the dynamic text column.
    flex: '0 0 105px',
};
var dynamicTextColumn = {
    flex: 1,
};
var MetricMetadataPanel = /** @class */ (function (_super) {
    __extends(MetricMetadataPanel, _super);
    function MetricMetadataPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderMetadataPanelOwnerSection = function () {
            var renderUser = function (ownerName) {
                if (_this.props.isHiddenInternalUser) {
                    return (React.createElement("div", { style: hiddenUserText }, ownerName));
                }
                else {
                    return (React.createElement(widgets_1.TextLinkWidget, { href: _this.props.ownerUrl, target: '_blank', testId: 'metadata-owner', id: 'metadata-owner-name', "aria-labelledby": 'metadata-owner-label metadata-owner-name' }, ownerName));
                }
            };
            if (!_this.props.ownerName) {
                return null;
            }
            return (React.createElement("div", { style: sectionMarginBotton },
                React.createElement("div", { style: metadataSubTitle, tabIndex: -1, id: 'metadata-owner-label' }, Localize_1.Messages.owner()),
                renderUser(_this.props.ownerName)));
        };
        _this.renderMetadataPanelDescriptionSection = function () {
            if (!_this.props.description) {
                return null;
            }
            return (React.createElement("div", { style: sectionMarginBotton },
                React.createElement("div", { style: metadataSubTitle }, Localize_1.Messages.description()),
                React.createElement("div", { style: metadataText }, _this.props.description)));
        };
        _this.renderMetadataPanelConnectedViewSection = function () {
            if (!_this.props.connectedViewtitle) {
                return null;
            }
            return (React.createElement("div", { style: sectionMarginBotton },
                React.createElement("div", { style: { marginBottom: '18px' } },
                    React.createElement("div", { style: metadataSubTitle, tabIndex: -1, id: 'metadata-connected-view-label' }, Localize_1.Messages.connectedView()),
                    React.createElement("div", { style: metadataText }, Localize_1.Messages.connectedViewSubTitle())),
                React.createElement(widgets_1.TextLinkWidget, { style: __assign({}, metadataConnectedView, { backgroundImage: "url(\"" + _this.props.connectedViewThumbnailUrl + "\")" }), href: _this.props.connectedViewUrl, target: '_blank', testId: 'metadata-connected-view-image', "aria-labelledby": 'metadata-connected-view-label metadata-connected-view-title' }),
                React.createElement("div", null,
                    React.createElement(widgets_1.TextLinkWidget, { href: _this.props.connectedViewUrl, target: '_blank', testId: 'metadata-connected-view', id: 'metadata-connected-view-title', "aria-labelledby": 'metadata-connected-view-label metadata-connected-view-title' }, _this.props.connectedViewtitle))));
        };
        _this.renderMetadataPanelDefinitionSection = function () {
            if (!_this.props.schemaMeasure && !_this.props.schemaTimestamp) {
                return null;
            }
            var renderDimensionTitle = function () {
                if (!_this.props.schemaTimestamp) {
                    return null;
                }
                return (React.createElement("div", { style: metadataText }, Localize_1.Messages.dateDimension()));
            };
            var renderDimensionValue = function () {
                if (!_this.props.schemaTimestamp) {
                    return null;
                }
                return (React.createElement("div", { style: metadataText }, _this.props.schemaTimestamp));
            };
            return (React.createElement("div", { style: sectionMarginBotton },
                React.createElement("div", { style: metadataSubTitle }, Localize_1.Messages.definition()),
                React.createElement("div", { style: flexRow },
                    React.createElement("div", { style: fixedFlexColumn },
                        React.createElement("div", { style: metadataText }, Localize_1.Messages.measure())),
                    React.createElement("div", { style: dynamicTextColumn },
                        React.createElement("div", { style: metadataText }, _this.props.schemaMeasure))),
                React.createElement("div", { style: __assign({}, flexRow, { marginTop: '8px' }) },
                    React.createElement("div", { style: fixedFlexColumn },
                        React.createElement("div", { style: metadataText }, renderDimensionTitle())),
                    React.createElement("div", { style: dynamicTextColumn },
                        React.createElement("div", { style: metadataText }, renderDimensionValue())))));
        };
        _this.renderMetadataPanelProjectSection = function () {
            if (!_this.props.projectName) {
                return null;
            }
            return (React.createElement("div", { style: sectionMarginBotton },
                React.createElement("div", { style: metadataSubTitle, tabIndex: -1, id: 'metadata-project-label' }, Localize_1.Messages.project()),
                React.createElement("div", null,
                    React.createElement(widgets_1.TextLinkWidget, { href: _this.props.projectUrl, target: '_blank', testId: 'metadata-project', id: 'metadata-project-name', "aria-labelledby": 'metadata-project-label metadata-project-name' }, _this.props.projectName))));
        };
        _this.renderMetadataPanelModifiedSection = function () {
            return (React.createElement("div", { style: sectionMarginBotton },
                React.createElement("div", { style: metadataSubTitle }, Localize_1.Messages.modified()),
                React.createElement("div", { style: metadataText }, formatting_1.formatLastModifiedDate(_this.props.modifiedTimestamp))));
        };
        _this.renderMetadataPanelTagsSection = function () {
            if (_this.props.tags.length < 1) {
                return null;
            }
            return (React.createElement("div", { style: sectionMarginBotton },
                React.createElement("div", { style: metadataSubTitle }, Localize_1.Messages.tags()),
                React.createElement("div", { style: metadataText }, _this.props.tags ? _this.props.tags.join(', ') : null)));
        };
        return _this;
    }
    MetricMetadataPanel.prototype.render = function () {
        return (React.createElement("div", { className: metadataPanelStyle },
            React.createElement("div", null,
                React.createElement("div", { style: sectionMarginBotton },
                    React.createElement("div", { style: metadataTitle }, Localize_1.Messages.metricDetails()))),
            React.createElement("div", { className: columnContainer },
                React.createElement("div", { className: leftColumn },
                    this.renderMetadataPanelOwnerSection(),
                    this.renderMetadataPanelDescriptionSection(),
                    React.createElement("div", { style: sectionMarginBotton },
                        React.createElement("hr", { style: metadataHorizontalLine })),
                    this.renderMetadataPanelConnectedViewSection(),
                    this.renderMetadataPanelDefinitionSection(),
                    React.createElement("div", { style: sectionMarginBotton },
                        React.createElement("hr", { style: metadataHorizontalLine }))),
                React.createElement("div", { className: rightColumn },
                    this.renderMetadataPanelProjectSection(),
                    this.renderMetadataPanelModifiedSection(),
                    this.renderMetadataPanelTagsSection()))));
    };
    return MetricMetadataPanel;
}(React.PureComponent));
exports.MetricMetadataPanel = MetricMetadataPanel;
//# sourceMappingURL=MetricMetadataPanel.js.map